import { useRef, useEffect } from "react";
import { createUploadWidget, loadScript } from "@/utils/cloudinary";
import isempty from "lodash/isEmpty";

export const useCloudinaryWidget = () => {
  const widgetRef = useRef();
  useEffect(() => {
    loadScript();
    return () => {
      const widget = widgetRef.current;
      if (widget) {
        widget.destroy();
      }
    };
  }, []);
  const uploadPhoto = (options) =>
    new Promise(async (resolve) => {
      const uploaded = [];
      const widget = createUploadWidget({
        options,
        onUpload(data) {
          uploaded.push(data.public_id);
          // resolve(public_id);
        },
        onClose() {
          if (!isempty(uploaded)) {
            resolve(options?.multiple ? uploaded : uploaded[0]);
          }
          if (widgetRef.current) {
            widgetRef.current.destroy();
          }
        },
      });
      widgetRef.current = widget;
      widget.open();
    });
  return {
    uploadPhoto,
  };
};
